import { cn } from '../../lib/cn'
import { Eyebrow } from './Eyebrow'

interface SectionHeadProps {
  eyebrow: string
  title: string
  /** Centres the pair — the marketing treatment. Left-aligned inside sections. */
  centered?: boolean
  /** `gilt` eyebrow for pine grounds. */
  onDark?: boolean
  className?: string
}

/** Eyebrow over a Fraunces heading — how every section on the club opens. */
export function SectionHead({
  eyebrow,
  title,
  centered = false,
  onDark = false,
  className,
}: SectionHeadProps) {
  return (
    <div className={cn(centered && 'text-center', className)}>
      <Eyebrow tone={onDark ? 'gilt' : 'brass'}>{eyebrow}</Eyebrow>
      <h2
        className={cn(
          'mt-3 font-display text-[clamp(1.875rem,4vw,2.75rem)] font-medium leading-[1.04]',
          onDark ? 'text-paper' : 'text-pine',
        )}
      >
        {title}
      </h2>
    </div>
  )
}
